import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuardInjectable } from './services/helpers/auth-guard-injectable';
import { ApplicationErrorComponent } from './core/application-error/application-error.component';
import { ErrorComponent } from './core/error/error.component';
import { HomeModule } from './features/home/home.module';
import { LoginModule } from './features/login/login.module';
import { notLogedInGuardInjectable, notLogedInGuardInjectableAlt } from './services/helpers/notloggedin-guard-injectable';

const routes: Routes = [

  { path: 'home', redirectTo: 'home/dashboard', pathMatch: 'prefix' },
  { 
    path: 'home', 
    loadChildren: () => HomeModule, 
    canActivate: [ authGuardInjectable ] 
  },
  { 
    path: 'login', 
    loadChildren: () => LoginModule, 
    canActivate:[ notLogedInGuardInjectable ] 
  },
  { 
    path: 'error',
    children: [
      { path: 'unauthorized', component: ErrorComponent },
      { path: 'application', component: ApplicationErrorComponent },
    ],    
  },  
  {
    path: 'error', redirectTo: 'application', pathMatch: 'full',
  },
  { path: '**', redirectTo: 'home/dashboard' },
  { path: '', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
